/* Responsibility: Update filter value for rating widget */
import dom from '../lib/dom.js';
import preconditions from '../lib/preconditions.js';

const checkPreconditions = preconditions('minumumRatingFilter', {
    root: 'element',
    resultViewCriteria: 'object',
    eventHub: 'eventHub',
    activeClass: 'string',
    inactiveClass: 'string',
    defaultActiveElements: 'number',
    urlKey: 'string',
    urlQueryParams: 'object',
});

export default function setupMinimumRatingFilter(params) {
    checkPreconditions(params);

    function setStars(stars) {
        if (+stars === params.defaultActiveElements) {
            delete params.resultViewCriteria[params.urlKey];
        } else {
            params.resultViewCriteria[params.urlKey] = stars;
        }
        const starElement = params.root.querySelector(`#star${stars}`);
        if (starElement) {
            starElement.checked = true;
        }
    }

    function publishFiltersAddedRemoved(stars) {
        if (+stars === params.defaultActiveElements) {
            params.eventHub.publish('filters:removed', params.urlKey);
        } else {
            const starText = `${+stars === 5 ? stars : `${stars} - 5`} stjerner`;
            params.eventHub.publish('filters:added', {
                filterId: params.urlKey,
                text: starText,
                urlKey: params.urlKey,
                urlValue: stars,
                remove() {
                    setStars(params.defaultActiveElements);
                    params.eventHub.publish('filters:removed', params.urlKey);
                },
            });
        }
    }

    function clicked(el) {
        const selectedRating = el.currentTarget.getAttribute('data-minimum-rating');
        setStars(selectedRating);
        publishFiltersAddedRemoved(selectedRating);
        params.eventHub.publish('resultViewCriteria:changed');
    }

    function setStarsFromUrlQueryParams() {
        let stars = Number(params.urlQueryParams[params.urlKey]);
        if (!stars) {
            stars = params.defaultActiveElements;
        }
        setStars(stars);
        publishFiltersAddedRemoved(stars);
    }

    setStars(params.defaultActiveElements);
    setStarsFromUrlQueryParams();
    params.eventHub.subscribe('urlQueryParams:changed', setStarsFromUrlQueryParams);
    dom.on(params.root, 'click', 'input', clicked);
}
